<template>

  <!-- Participate Dialog -->
  <q-dialog
    full-width
    full-height
    ref="dialog"
    class="participate-dialog">

    <!-- Background -->
    <file-background
      no-placeholder
      :value="bgFile"
      :color="bgColor"
      class="participate-dialog__background ghost"/>

    <page-block
      overlay-class="q-my-auto"
      class="participate-dialog__content">

      <!-- Close -->
      <q-page-sticky
        :offset="[45, 30]"
        position="top-right">

        <q-btn
          round
          size="md"
          unelevated
          padding="md"
          color="white"
          @click="hide"
          text-color="primary"
          icon="fa lni-close"/>

      </q-page-sticky>

      <div
        class="participate-dialog__wrapper">

        <div
          class="row q-py-lg">

          <div
            class="col-12 col-md-6 column justify-center">

            <div
              class="q-mx-md-md q-pb-md">

              <!-- Title -->
              <div
                v-if="$u.localize(title)"
                class="participate-dialog__title"
                v-html="$u.nToBr($u.localize(title))"/>

              <!-- Body -->
              <div
                v-if="$u.localize(body)"
                v-html="$u.localize(body)"
                class="participate-dialog__body q-mt-md"/>

              <!-- Buttons -->
              <page-block-buttons
                :value="buttons"/>

            </div>

          </div>

          <div
            class="col-12 col-md-6">

            <!-- Success -->

            <div
              v-if="done">

              <div
                class="column items-center text-center">

                <q-icon
                  size="100px"
                  name="fa lni-check-mark-circle"/>

                <div
                  class="text-h3">

                  Спасибо!

                  <br/>

                  Ваши данные успешно отправлены.

                </div>

                <div
                  class="q-mb-none">
                  Проверьте электронную почту, указанную при регистрации и
                  убедитесь, что Вы получили письмо с дальнейшими инструкциями.
                  В случае, если Вы их не получили, напишите на почту
                  <a href="mailto:PshenichnayaIV@mos.ru">PshenichnayaIV@mos.ru</a>,
                  <nobr>Ирина Пшеничная</nobr>
                </div>

              </div>

              <div
                class="q-mt-lg row justify-center">

                <q-btn
                  to="/"
                  rounded
                  unelevated
                  color="white"
                  :loading="loading"
                  :disabled="loading"
                  text-color="primary"
                  class="q-mt-xs-sm q-mt-sm-none">
                  Продолжить
                </q-btn>

              </div>

            </div>

            <q-form
              v-else
              class="q-mx-md-md"
              @submit.prevent="submit">

              <div
                class="participate-dialog__form-title">
                Записаться
              </div>

              <q-input
                rounded
                standout
                lazy-rules
                class="q-mt-sm"
                placeholder="Фамилия"
                v-model="data.surname"
                :rules="[v => v && v.length > 1 || 'Не менее 2-х символов']"/>

              <q-input
                rounded
                standout
                lazy-rules
                class="q-mt-sm"
                placeholder="Имя"
                v-model="data.name"
                :rules="[v => v && v.length > 1 || 'Не менее 2-х символов']"/>

              <q-input
                rounded
                standout
                class="q-mt-sm"
                placeholder="Отчество"
                v-model="data.middleName"/>

              <q-input
                rounded
                standout
                lazy-rules
                class="q-mt-ss"
                v-model="data.email"
                placeholder="E-mail"
                :rules="[
                  v => !!v || 'Обязательное поле',
                  v => (!v || $validator.isEmail(v)) || 'Неверный формат'
                ]"/>

              <q-input
                rounded
                standout
                lazy-rules
                class="q-mt-ss"
                v-model="data.phone"
                placeholder="Номер телефона"
                :rules="[v => v && v.length > 1 || 'Не менее 2-х символов']"/>

              <q-input
                rounded
                standout
                class="q-mt-ss"
                v-model="data.company"
                placeholder="Компания"/>

              <q-input
                rounded
                standout
                class="q-mt-ss"
                v-model="data.position"
                placeholder="Должность"/>

              <q-input
                rounded
                standout
                class="q-mt-ss"
                type="textarea"
                v-model="data.comment"
                placeholder="Ваш вопрос спикерам"/>

              <checkbox-field
                lazy-rules
                class="q-mt-md"
                v-model="data.privacyAgreed"
                :rules="[v => !!v || 'Обязательное поле']">

                <template
                  slot="label">

                  Согласие на обработку персональных данных

                  <a
                    href="#"
                    target="_blank"
                    class="text-underline text-white">
                    link
                  </a>

                </template>

              </checkbox-field>

              <q-btn
                rounded
                unelevated
                type="submit"
                :loading="loading"
                :disable="loading"
                class="q-mt-md participate-dialog__submit">
                Отправить
              </q-btn>

            </q-form>

          </div>

        </div>

      </div>

    </page-block>

  </q-dialog>

</template>

<script>

  import {mapActions, mapState} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import CheckboxField from '@src/components/form/checkbox-field';
  import FileBackground from '@src/components/file/file-background';
  import PageBlockButtons from '@src/components/page/page-block-buttons';

  export default {
    name: 'participate-dialog',
    props: {
      title: {
        type: [String, Object],
        default: '',
      },
      body: {
        type: [String, Object],
        default: '',
      },
      bgFile: {
        type: Object,
        default: null,
      },
      bgColor: {
        type: String,
        default: '',
      },
      buttons: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      FileBackground,
      PageBlock,
      CheckboxField,
      PageBlockButtons,
    },
    data() {
      return {
        done: false,
        data: {
          name: '',
          surname: '',
          middleName: '',
          email: '',
          phone: '',
          company: '',
          position: '',
          comment: '',
          privacyAgreed: false,
        },
      };
    },
    computed: {
      ...mapState('vlApplications', {
        loading: 'loading',
      }),
    },
    methods: {
      ...mapActions('vlApplications', {
        send: 'SUBMIT',
      }),
      show() {

        this.$refs.dialog.show();
      },
      hide() {

        this.$refs.dialog.hide();
      },
      async submit() {

        const response = await this.$store.dispatch(
          'vlApplications/SUBMIT',
          this.data,
        );

        this.done = !!response;
      },
    },
  };

</script>

<style lang="scss">

  .participate-dialog {
    color: inherit;

    .page-block__wrapper {
      max-width: 1200px;
    }

    &__submit {
      color: $primary;
      font-weight: bold;
      letter-spacing: 1px;
      background-color: white !important;
    }

    &__form-title {
      font-size: 1.4rem;
      font-weight: bold;
      margin-left: 21px;
      text-transform: uppercase;
    }

    &__background {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    &__background {
      background-color: $primary;
    }

    &__background.ghost > * {
      opacity: .4;
    }

    &__wrapper {
      // max-width: 720px;
      display: block;
    }

    &__title {
      font-size: 3rem;
      font-weight: 600;
      line-height: 3.4rem;
    }

    &__body {
      font-size: 1.1rem;
    }

    &__wrapper > * {
      margin-bottom: 0;
    }

    &__wrapper > *:not(:first-child) {
      margin-top: $spacer-lg;
    }

    @media (max-width: $breakpoint-xs) {

      &__title {
        font-size: 2rem;
        line-height: 2.5rem;
      }

      &__body {
        font-size: 1rem;
      }

      &__wrapper > *:not(:first-child) {
        margin-top: $spacer-sm;
      }
    }
  }

  .participate-dialog__content {
    color: white;
    display: flex;
    align-items: center;
    flex-direction: row;
    background: $brand-gradient;

    a:not(.q-btn) {
      color: inherit;
      font-weight: 500;
      text-decoration: underline;
    }

    .q-field__label,
    .q-field__control {
      color: inherit !important;
    }

    .q-field--standout .q-field__control {
      padding: 0 1.5rem;
      box-shadow: none !important;
      background-color: rgba(0, 0, 0, 0.2);
    }

    .q-field__native,
    .q-field__prefix,
    .q-field__suffix,
    .q-field__input {
      font-weight: 500;
      color: white !important;
    }

    .q-field input::placeholder,
    .q-textarea textarea::placeholder {
      opacity: 1;
      font-weight: 400 !important;
      color: white !important;
    }

    .q-field__control,
    .q-field__marginal {
      height: 2.8rem;
      color: inherit;
    }

    .q-textarea .q-field__control {
      height: auto;
    }

    .q-checkbox__bg {
      border-color: white;
    }

    .q-checkbox__inner--truthy .q-checkbox__bg,
    .q-checkbox__inner--indet .q-checkbox__bg {
      background-color: white;
    }

    .q-checkbox__svg {
      color: $accent !important;
    }

    .q-field__bottom {
      color: white;
    }

    .q-field--error .q-field__bottom {
      color: lighten($warning, 20);
      text-shadow: 1px 1px 2px rgba(0, 0, 0, .2);
    }

    .q-field__append.q-field__marginal .lni-warning {
      color: $warning !important;
    }

    .q-field--with-bottom:not(.q-field--error) {
      padding-bottom: 0;
    }
  }

</style>
